import { PropsWithChildren } from 'react'

type InputHintProps = PropsWithChildren

export default function InputHint({ children }: InputHintProps) {
  return (
    children && <p className="type-body-10 text-neutral-600 my-2">{children}</p>
  )
}
